<template>
  <div class="show-hide-icon" @click="toggleClick"></div>
  <!-- <img class="hide" src="../../assets/images/menu/hide.png" alt="" @click="toggleClick"> -->

</template>

<script>
export default {
  name: 'Hamburger',
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    toggleClick() {
      this.$emit('toggleClick');
    },
  },
};
</script>

<style scoped>
.hamburger {
  display: inline-block;
  width: 20px;
  height: 20px;
  vertical-align: middle;
}

.hamburger.is-active {
  transform: rotate(180deg);
}

.hide-sidebar .show-hide-icon {
  background: url(../../assets/images/menu/show.png) no-repeat;
  background-size: 100%;
}

.open-sidebar .show-hide-icon {
  background: url(../../assets/images/menu/hide.png) no-repeat;
  background-size: 100%;
}

.show-hide-icon {
  width: 24px;
  height: 24px;
  cursor: pointer;
}
</style>
